import MDBox from "../../../components/MDBox";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import MDTypography from "../../../components/MDTypography";
import React, {useEffect, useState} from "react";
import MDButton from "../../../components/MDButton";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import PaperComponent from "../../../components/MuiDraggableDialog";
import {cargoOwnerCarrierEdit, cargoOwnerInfo, getAllWarehouseList,} from "../../../actions/inventory/inventoryAction";
import {useDispatch, useSelector} from "react-redux";
import {LoadingButton} from "@mui/lab";
import FramerFade from "../../../components/Animation/Fade";
import LocalStorage from "../../../utils/LocalStorage";
import {getUserSetting, Logout, onErrorAlert, onSuccessAlert} from "../../../actions";
import {noop} from "lodash";
import {carrier_List} from "../../../actions/outbounds/outboundsAction";
import {checkPermission, PERMISSION_DICT} from "../../../utils/Users_Roles_Permission";
import {useTranslation} from "react-i18next";

const UserCarrierEdit = ({setOpen, open, owner, userInfo, parent ,signUpHandler, signUpList, signUpBackward}) => {
    const [view, setView] = useState("preview")
    const haveCard = useSelector(state => state?.system?.haveCard,(prev, next) => prev === next)
    const ownerInfo = useSelector(state => state?.inventory?.ownerInfo,(prev, next) => prev === next)
    const [selectedList, setSelectedList] = useState([])
    const [activeStep, setActiveStep] = useState(0);
    const [loading, setLoading] = useState(false)
    const carrierList = useSelector(state => state?.outbounds?.carrierList,(prev, next) => prev === next)
    const {t} = useTranslation()
    useEffect(() => {
        if (parent === "cargoOwner"){
            setSelectedList(ownerInfo?.ownerResp?.acceptedCarriers || [])
        }
        if (parent === "userInfo"){
            setSelectedList(userInfo?.carrierList || [])
        }
        if (parent === "signUp"){
            setSelectedList(signUpList)
        }
    }, [ownerInfo, userInfo ,signUpList]);



    const dispatch = useDispatch()

    const handleSelect = (e, carrier) => {
        if (e.target.checked) {
            setSelectedList((prevState) => ([...prevState, carrier]))
        } else {
            setSelectedList((prevState) => ([...selectedList].filter(item => item !== carrier)))
        }
    }

    const onError = (msg, code) => {
        dispatch(onErrorAlert(msg))
        setLoading(false)
        setSelectedList(ownerInfo?.ownerResp?.acceptedCarriers || userInfo?.carrierList || [])
        // setPageLoading(false)
        if (code === 401) {
            dispatch(Logout(noop))
            nav('/')
        }
    }

    const onSuccess = async (msg) => {
        dispatch(onSuccessAlert(t(msg)))
        if (parent === "cargoOwner"){
            dispatch(cargoOwnerInfo({ ownerId: ownerInfo?.ownerResp?.ocpOwnerId,
                userName: LocalStorage.getItem('username')}))
        }
        if (parent === "userInfo"){
            dispatch(getUserSetting())
        }

        setOpen(false)
        setLoading(false)
        setView("preview")
        setActiveStep(0)
    }

    return (
        <React.Fragment>
            <Dialog
                PaperComponent={PaperComponent}
                fullWidth={true}
                maxWidth={'md'}
                open={open}
                onClose={() => {
                    setOpen(false)
                    setView("preview")
                    setSelectedList([])
                    setActiveStep(0)
                }}
                aria-labelledby="draggable-dialog-title"
            ><DialogTitle id="draggable-dialog-title" style={{cursor: 'move'}}>
                <MDTypography variant={'h5'}>
                </MDTypography>
            </DialogTitle>
                <DialogContent>
                    <MDBox
                        variant="gradient"
                        bgColor="info"
                        borderRadius="lg"
                        coloredShadow="success"
                        mx={2}
                        mt={2}
                        p={3}
                        mb={1}
                        textAlign="center"
                    >
                        <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                            {t('CustomerPage.Carriers Management')}
                        </MDTypography>
                        {/*<MDTypography display="block" variant="button" color="white" my={1}>*/}
                        {/*    Select Carriers  by cargo owner : {owner}*/}
                        {/*</MDTypography>*/}
                    </MDBox>
                    <MDBox pt={4} pb={2} px={3} sx={{overflow: "hidden"}}>
                        <FramerFade isActive={activeStep === 0} delay={0}>
                            <MDBox component="form" role="form">
                                <div style={{overflow: "hidden"}}>
                                    <MDBox ml={1.5}>
                                        <FormControl>
                                            <FormGroup>
                                                <Grid container>
                                                    {carrierList.map((carrier, index) => {
                                                        return (
                                                            <Grid item md={4} xs={12} key={index}>
                                                                <MDBox sx={{
                                                                    border: (selectedList?.indexOf(carrier.dictValue) !== -1 ? "2px solid #3d97ef" : "2px solid lightGray"),
                                                                    paddingLeft: "10px",
                                                                    borderRadius: "10px",
                                                                    marginRight: "3px",
                                                                    marginTop: "3px"
                                                                }}>
                                                                    <FormControlLabel control={<Checkbox/>}
                                                                                      checked={selectedList?.indexOf(carrier.dictValue) !== -1}
                                                                                      onChange={
                                                                                          (e) => {
                                                                                              handleSelect(e, carrier.dictValue)
                                                                                          }} label={<div style={{fontSize:"13px"}}>{carrier.dictValue}</div>}/>
                                                                </MDBox>
                                                            </Grid>
                                                        )
                                                    })}
                                                </Grid>
                                            </FormGroup>
                                        </FormControl>
                                        <MDBox mt={2} sx={{display: "flex"}}>
                                            <Button variant="text" size="small"
                                                    disabled={!checkPermission(PERMISSION_DICT.CustomerCargoCarrierModify)}
                                                    onClick={() => {
                                                        let fullList = carrierList.map((carrier, index) => {
                                                            return carrier.dictValue
                                                        })
                                                        setSelectedList(fullList)
                                                    }}
                                            >{t('Select All')}</Button>

                                            <Button variant="text" size="small"
                                                    onClick={() => {
                                                        setSelectedList([])
                                                    }}
                                            >{t('Remove All')}</Button>
                                            <Button variant="text" size="small"
                                                    onClick={() => {
                                                        if (parent === "cargoOwner"){
                                                            setSelectedList(ownerInfo?.ownerResp?.acceptedCarriers)
                                                        }
                                                        if (parent === "userInfo"){
                                                            setSelectedList(userInfo?.carrierList)
                                                        }
                                                        if (parent === "signUp"){
                                                            setSelectedList([])
                                                        }

                                                    }}
                                            >{t('reset')}</Button>

                                        </MDBox>
                                    </MDBox>
                                    <MDBox sx={{display: "flex", justifyContent: "flex-end"}}>
                                        <MDButton sx={{marginRight: "20px"}} variant="outlined" color="info"
                                                  onClick={() => {
                                                      if(parent === "signUp" ){
                                                          signUpBackward(selectedList)
                                                      }
                                                     else {
                                                          setSelectedList([])
                                                          setOpen(false)
                                                          setView("preview")
                                                          setActiveStep(0)
                                                      }
                                                  }}>

                                            {
                                                parent === "signUp" ? t("Back"):  t("Cancel")
                                            }
                                        </MDButton>
                                        <LoadingButton
                                            disabled={!checkPermission(PERMISSION_DICT.CustomerCargoCarrierModify)}
                                            loading={loading}
                                            variant="contained"
                                            onClick={() => {
                                                if (parent === "cargoOwner"){
                                                    setLoading(true)
                                                    dispatch(cargoOwnerCarrierEdit(
                                                        {
                                                            acceptedCarriers:selectedList,
                                                            ocpOwnerId:ownerInfo?.ownerResp?.ocpOwnerId,
                                                            omsOwnerId:ownerInfo?.ownerResp?.omsOwnerId,
                                                            userName: LocalStorage.getItem("username")
                                                        },onSuccess,onError
                                                    ))
                                                }
                                                if (parent === "userInfo"){
                                                    setLoading(true)
                                                    dispatch(cargoOwnerCarrierEdit(
                                                        {
                                                            acceptedCarriers:selectedList,
                                                            ocpOwnerId:userInfo?.ownerId,
                                                            omsOwnerId:userInfo?.omsOwnerId,
                                                            userName: LocalStorage.getItem("username")
                                                        },onSuccess,onError
                                                    ))
                                                }
                                                if (parent === "signUp"){
                                                    if(selectedList.length === 0 ) {
                                                        dispatch(onErrorAlert(("Need to choose at least one carrier.")))
                                                    }else {
                                                        signUpHandler(selectedList)
                                                    }

                                                }
                                            }}
                                        >
                                            {
                                                parent === "signUp" ? t("Continue"):  t("Confirm")
                                            }

                                        </LoadingButton>
                                    </MDBox>
                                </div>
                            </MDBox>
                        </FramerFade>
                    </MDBox>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    )
}

export default UserCarrierEdit